import { Link } from 'react-router';
import { CalendarRange } from 'lucide-react';
import { Pastilla } from '@/components/Card';
import { textoPosicion, textoPosicionCorto, type PosicionEnPlan } from '@/domain/etapas';

/**
 * "Déficit · semana 3 de 6" junto al título de Hoy y de Comida (reacomodo de
 * la 0.11.0).
 *
 * Antes era un párrafo con el detalle completo. Ahora la pastilla dice la
 * etapa y la semana, que es lo que se consulta de un vistazo, y lleva a Mi
 * plan, donde el detalle sigue completo: el día del ciclo y los días que
 * faltan. El texto largo va en el nombre accesible, así que quien usa un
 * lector de pantalla lo escucha sin salir de la pantalla.
 */
export function PastillaDeEtapa({ posicion }: { posicion: PosicionEnPlan }) {
  const detalle = textoPosicion(posicion);
  return (
    <Link
      to="/mas/plan"
      aria-label={`${posicion.empiezaHoy ? 'Hoy empieza: ' : ''}${detalle}. Ver mi plan`}
      className="inline-flex active:opacity-60"
    >
      <Pastilla>
        <CalendarRange aria-hidden="true" className="size-3.5" />
        {textoPosicionCorto(posicion)}
      </Pastilla>
    </Link>
  );
}
